/** @jsxImportSource react */
import Script from 'next/script';

import './naverWcsWindow';

export function NaverWCS() {
  return (
    <Script
      id="naver-wcs"
      src="https://wcs.naver.net/wcslog.js"
      strategy="afterInteractive"
      onLoad={() => {
        if (!window.wcs_add) {
          window.wcs_add = {};
        }

        window.wcs_add.wa = 's_2652984f26f1';
        window._nasa = window._nasa || {};

        if (window.wcs) {
          window.wcs.inflow('myrealtrip.com');
          window.wcs_do(window._nasa);
        }
      }}
    />
  );
}
